import { render } from "./AddSensor.vue?vue&type=template&id=817ff49a"
import script from "./AddSensor.vue?vue&type=script&lang=js"
export * from "./AddSensor.vue?vue&type=script&lang=js"

import "./AddSensor.vue?vue&type=style&index=0&id=817ff49a&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"
script.render = render

export default script